/**
 * Domain Section Transformers
 * Aggregates all domain-related transformers and provides section-level utilities
 */

import { transformDomainRegistration } from './domainRegistrationTransformer';
import { transformDomainAvailability } from './domainAvailabilityTransformer';
import { transformTypoAvailability } from './typoAvailabilityTransformer';

// Re-export individual transformers
export { transformDomainRegistration } from './domainRegistrationTransformer';
export { transformDomainAvailability } from './domainAvailabilityTransformer';
export { transformTypoAvailability } from './typoAvailabilityTransformer';

/**
 * Transforms all domain section criteria from WooRank API response
 * @param {Object} apiData - The SEO audit data object (already response.data from API)
 * @returns {Object} - Transformed domain section data with aggregated counts
 */
export const transformDomainSection = (apiData = {}) => {
  const criteria = apiData?.criteria || {};

  const domainRegistration = transformDomainRegistration(criteria?.domain_registration);
  const domainAvailability = transformDomainAvailability(criteria?.tld_cybersquating_prevention);
  const typoAvailability = transformTypoAvailability(criteria?.typo_cybersquating_prevention);

  const allResults = [domainRegistration, domainAvailability, typoAvailability];
  const errorCount = allResults.filter((r) => r?.status === 'error').length || 0;
  const toImproveCount = allResults.filter((r) => r?.status === 'warning').length || 0;

  return {
    errorCount,
    toImproveCount,
    domainRegistration,
    domainAvailability,
    typoAvailability,
  };
};

export default transformDomainSection;


